module.exports = __webpack_public_path__ + "img/prime.f59a0a0c.svg";